import { useEffect, useState } from "react"
import { api } from "../../../../env"
import { ConfirmButton } from "../../../../components/ConfirmButton"
import Input, { useNumberInput } from "../../../../components/input"

export default function ProgramsQuotaCard({ companyId }) {
    const [company, setCompany] = useState(null)
    const amount = useNumberInput("Amount", null, [], 1)

    const fetch = () => api.get(`companies/${companyId}`).then(res => setCompany(res.data))

    useEffect(() => { fetch() }, [companyId])

    const adjustQuota = (direction) => {
        const delta = Number(amount._value) * direction
        api.put(`companies/${companyId}`, { programsQuota: company.programsQuota + delta })
            .then(fetch)
            .catch(() => {})
    }

    if (!company) return null

    const total = company.programsQuota
    const used = company.totalPrograms
    const remaining = total - used

    return (
        <div className="card flex columns gap-s v-spacer-s">
            <p className="card-title">Programs Quota</p>
            <div className="flex columns gap-xs">
                <p className="card-body">Total: <span className="medium">{total}</span></p>
                <p className="card-body">Used: <span className="medium">{used}</span></p>
                <p className="card-body accent">Remaining: <span className="medium">{remaining}</span></p>
            </div>
            <div className="flex gap-xs center">
                <div style={{ width: 100 }}>
                    <Input state={amount} />
                </div>
                <ConfirmButton label="Decrease" onClick={() => adjustQuota(-1)} className="outline large"/>
                <ConfirmButton label="Increase" onClick={() => adjustQuota(1)} className="solid large" />
            </div>
        </div>
    )
}
